export default __webpack_public_path__ + "static/media/avenus-logo.06bb1f4d.svg";